module.exports = __webpack_public_path__ + "media/customizations/blackwoodgroves/logo-c3d5cc05ade8e1b2dc5c7de6bc7ac582.png";